
import React, { useMemo, useCallback, useState } from 'react';
import Tabs from '../TabComponent';
import { LABEL } from '../../../veriables';
import { getImageUrl } from '@utility/utills';
import cn from 'classnames';
import MoreInfo from '../moreInfo';
import { TouchableButton } from '@components/common/Touchable';
import getDeviceType from '@utility/deviceType';
import style from '../orderItemDetail.module.scss';
import NutritionFacts from './NutritionFacts';
import ItemFactsPane from './ItemFactsPane';
import FullWidthModal from '../../common/Modal/FullWidthModal';
import ModalHeader from '../../common/ModalHeader/index';

const IS_KIOSK = getDeviceType().isKiosk;

const DIVIDER_STYLE = { borderBottom: '2px solid #575757' };
const CLOSE_BTN_POSITION = { bottom: '1.3rem', position: 'absolute', gap: '12px' };

const HEADER_STYLE = { position: 'relative', height: '40px' };
const HEADER_LEFT_STYLE  = { flex: 1, textAlign: 'left' };
const HEADER_CENTER_STYLE = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  pointerEvents: 'none',
};
const HEADER_RIGHT_STYLE = { flex: 1, textAlign: 'right' };

const LABELS = LABEL();

const Pane = ({ children }) => <div className="h-100" style={{ overflowY: 'auto' }}>{children}</div>;


const NutritionInfoV2 = React.memo(({ itemInfo, serverAppTheme, seat, onClose, addToCart }) => {
  const ItemDetails = itemInfo?.menuItem;
  const itemDetailsInfo = itemInfo;

const handleClose = useCallback((e) => {
  e?.preventDefault();
  onClose?.();
}, [onClose]);

  const handleKioskAdd = useCallback(() => {
    onClose?.();
    if (addToCart) {
      addToCart(itemDetailsInfo?.menuItemId, itemDetailsInfo?.menuTypeId, [], 'order');
    }
  }, [onClose, addToCart, itemDetailsInfo?.menuItemId, itemDetailsInfo?.menuTypeId]);

  const { imgSrc, imgClassName } = useMemo(() => {
    if (!ItemDetails) return { imgSrc: '', imgClassName: '' };
    if (ItemDetails.imageUrl) {
      const src = getImageUrl(ItemDetails, 'itemDetail', window.screen.width);
      return { imgSrc: src, imgClassName: cn(style.itemImage, src ? 'rounded' : 'd-none') };
    }
    const src = getImageUrl(ItemDetails.imageUrl);
    return { imgSrc: src, imgClassName: cn(style.itemImage, src ? 'rounded' : 'd-none') };
  }, [ItemDetails]);

  const closeBtnStyle = useMemo(
    () => ({
      background: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    }),
    [serverAppTheme?.secondaryBtn, serverAppTheme?.btn_font_color]
  );

  if (!ItemDetails) return null;
  const [showLargeImage, setShowLargeImage] = useState(false);
   const originalImageUrl = ItemDetails?.imageUrl;


  return (
    <>
      <div
        className={cn(
          'w-100 d-flex align-items-center px-2 py-1 fw-600 fs-20 modal_headers_background_color',
          style.modalHeaderText
        )}
        style={HEADER_STYLE}
      >
        <div className="fs_16" style={HEADER_LEFT_STYLE}>
          {seat?.stationName
            ? `${seat.tab ? 'Tab' : 'Table'} : ${
                seat.stationName.length > 8
                  ? `${seat.stationName.substring(0, 8)}...`
                  : seat.stationName
              }`
            : ''}
        </div>
        <div className="fs_18 fw-600" style={HEADER_CENTER_STYLE}>Facts</div>
        <div className="fs_16" style={HEADER_RIGHT_STYLE}>
          {seat?.number ? `#${seat.number}` : ''}
        </div>
      </div>

      {!IS_KIOSK ? (
        <>
          <Tabs serverAppTheme={serverAppTheme}>
            <Pane label={LABELS.ITEM_FACTS}>
              <ItemFactsPane
                ItemDetails={ItemDetails}
                imgSrc={imgSrc}
                imgClassName={imgClassName}
              />
            </Pane>

            {ItemDetails.nutritionFact && (
              <Pane label={LABELS.NUTRITION_FACT}>
                <div
                  className={cn('d-flex justify-content-start')}
                  style={DIVIDER_STYLE}
                >
                  <div className={cn('fw-600 w-100 fs_26')}>
                    {LABELS.NUTRITION_FACT}
                  </div>
                </div>
                <NutritionFacts nf={ItemDetails.nutritionFact} />
              </Pane>
            )}
          </Tabs>

          <div
            className="col-12 px-4 d-flex justify-content-center align-items-center"
            style={CLOSE_BTN_POSITION}
          >
            <TouchableButton
              className={cn('btn44 w-100 fs_24 col-6 px-0', style.viewLargeImageBtn, style.marginRight)}
              disabled={!originalImageUrl}
              style={
                !originalImageUrl
                  ? {
                    backgroundColor: serverAppTheme?.secondaryBtnDisabled,
                    color: serverAppTheme?.btn_font_color_disabled,
                    borderColor: serverAppTheme?.secondaryBtnDisabled,
                  }
                  : {}
              }
              onClick={(e) => { e.preventDefault(); setShowLargeImage(true); }}
              rippleEffect={true}
            >
              {LABEL().VIEW_LARGE_IMAGE}
            </TouchableButton>
            <TouchableButton
              className={cn('btn44 w-100 fs_24 col-6 px-0', style.primary_btn)}
              style={closeBtnStyle}
              onClick={handleClose}
              rippleEffect={true}
            >
              Close
            </TouchableButton>
          </div>
        </>
      ) : (
        <div className="h-100">
          <div className="h-90">
            <MoreInfo
              setInfo={onClose}
              info={true}
              ItemDetails={ItemDetails}
              itemDetailsInfo={itemDetailsInfo}
              addToCart={addToCart}
            />
          </div>
          <div className="col-12 p-2 row mx-0 align-items-end h-10">
            {IS_KIOSK && (
              <div className="col-6">
                <button
                  disabled={
                    ItemDetails.outOfStock ||
                    ItemDetails.badge === 1 ||
                    ItemDetails.badge === 6
                  }
                  className={cn(
                    'btn btn100 btn-ripple shadow-none border-0 fw-700 w-100 fs-22'
                  )}
                  type="button"
                  onClick={handleKioskAdd}
                >
                  {LABELS.ADD_TO_ORDER}
                </button>
              </div>
            )}
            <div className={IS_KIOSK ? 'col-6' : 'col-12'}>
              <button
                className={cn(
                  'btn btn100 btn-ripple shadow-none border-0 fw-700 w-100 fs-22'
                )}
                type="button"
                onClick={handleClose}
              >
                {LABELS.DONE}
              </button>
            </div>
          </div>
        </div>
      )}
      {showLargeImage && (
        <FullWidthModal
          isOpen={showLargeImage}
          toggleModal={() => { setShowLargeImage(false); }}
          customClass={''}
          customClass2='h-100 w-100'
          style={{ width: '100%', backgroundColor: serverAppTheme?.popUp_bg, border: serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow, height: '100%' }}
        >
          <div className={cn(style.modalHeaderText)}>
            <ModalHeader
              isTab={seat?.tab}
              stationName={seat?.stationName}
              tileHeader="Image"
              seatNumber={seat?.number}
            />
          </div>
          <div className={style.largeImageScrollContainer}>
            <img src={originalImageUrl} alt="" />
          </div>
          <div className='col-12 p-0 d-flex justify-content-center align-items-center' style={{ bottom: '1rem', position: 'absolute' }}>
            <TouchableButton
              className={cn('btn44 w-100 fs_24 col-6 px-0', style.primary_btn)}
              style={{ background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
              onClick={(e) => { e.preventDefault(); setShowLargeImage(false); }}
              rippleEffect={true}
            >
              Close
            </TouchableButton>
          </div>
        </FullWidthModal>
      )}
    </>
  );
});

export default NutritionInfoV2;
